import store from '../config/configureStore';

export const SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD = 'SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD';
export const SET_INC_ATTACHMENTS = 'SET_INC_ATTACHMENTS';
export const SET_ATTCHMENT_SIZE_LIMIT = 'SET_ATTCHMENT_SIZE_LIMIT';

export const setSelectedAttachmentsForDownload = (attachemnts) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD, payload: attachemnts });
  };
};

export const resetSelectedAttachmentsForDownload = () => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD, payload: [] });
  };
};

export const setIncAttachments = (attachments) => {
  return (dispatch) => {
    dispatch({ type: SET_INC_ATTACHMENTS, payload: attachments });
  };
};

export const getAttachmentSizeLimit = () => {
  const client = store.store.getState().websocket.websocket;
  return async (dispatch) => {
    try {
      const cdrService = client.service('cdr');
      cdrService.timeout = 20000;
      const data = await cdrService.get({
        Path: 'Attachment.FileSize',
        CDRKey: 'SizeLimit',
      });
      dispatch({
        type: SET_ATTCHMENT_SIZE_LIMIT,
        payload: data && data.length > 0 && data[0].ValueNumeric !== 0 ? data[0].ValueNumeric : 100,
      });
    } catch (error) {
      console.error('Failed to fetch size limit:', error);
    }
  };
};

export default function reducer(
  state = {
    selectedDownloadAttachments: [],
    incAttachments: [],
    sizelimit: 100,
  },
  action
) {
  switch (action.type) {
    case SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD:
      return {
        ...state,
        selectedDownloadAttachments: action.payload,
      };
    case SET_INC_ATTACHMENTS:
      return {
        ...state,
        incAttachments: action.payload,
      };
    case SET_ATTCHMENT_SIZE_LIMIT:
      return {
        ...state,
        sizelimit: action.payload,
      };
  }

  return state;
}
